// TODO: 融資融券未測試
import { Component, ElementRef, OnInit, ViewChild, inject, input } from '@angular/core';
import {
  JkBaseComponent,
  JkOpenwinParams,
} from 'jk-service';
import { StktsService } from '../services/stkts.service';
import { MaterialModule } from 'jk-service';
import { idNameItem, jkLib, jkRestReturn } from 'jk-service';
import { StockService } from '../services/stock.service';
import { StklgService } from '../services/stklg.service';
import { StkmaService } from '../services/stkma.service';
import { StkmbService } from '../services/stkmb.service';
import { Stklg } from '../entity/Stklg-angular';
import { CommonModule, DatePipe } from '@angular/common';
import { sendButtonStyle } from '../services/stock.service';
import { RowDoubleClickedEvent } from 'ag-grid-community';
import { StklmService, StkmqService } from '../_service_stk';
import { JackBaseComponentModule } from 'jk-service';
import { JkgridwinComponent } from 'jk-advcom';
import { buysaleList } from '../capitalClass';
import { Stkmq, Stkts } from '../_entity_stk';

// 價格 委託價格，0:限價 「M」表示參考價（昨收價）、「H」表示漲停價、「L」表示跌停價
const priceTypeList: idNameItem[] = [
  { id: '0', name: '限價' },
  { id: 'M', name: '昨收價' },
  { id: 'H', name: '漲停價' },
  { id: 'L', name: '跌停價' },
];

@Component({
  selector: 'app-tw-stock-order',
  standalone: true,
  imports: [MaterialModule, JackBaseComponentModule, DatePipe, CommonModule, JkgridwinComponent],
  templateUrl: './tw-stock-order.component.html',
  //styleUrl: './tw-stock-order.component.css'
  styles: [sendButtonStyle],
})
export class TwStockOrderComponent extends JkBaseComponent implements OnInit {
  stktsSrv = inject(StktsService);
  stkmaSrv = inject(StkmaService);
  stklmSrv = inject(StklmService);
  stockSrv = inject(StockService);
  stklgSrv = inject(StklgService);
  stkmqSrv = inject(StkmqService);

  /*@ViewChild('zoomDiv') zoomDiv!: ElementRef;
  isZoomed: boolean = false;
  doZoomChange() {
    this.isZoomed = !this.isZoomed;
    if (this.isZoomed) {
      //this.zoomDiv.nativeElement.style.width = this.pWidth.toString()+"px";
    } else {
      //this.zoomDiv.nativeElement.style.width = '350px';
    }
  }
  @Input() pWidth: number = 350;
  */
  readonly stkmbSrv = input.required<StkmbService>();
  stktsGrid!: JkgridwinComponent;
  //quoteGrid!: JkgridwinComponent;
  balanceGrid!: JkgridwinComponent;
  replyGrid!: JkgridwinComponent;
  date: string = jkLib.nowDate();
  buysaleList: idNameItem[] = buysaleList;
  priceTypeList: idNameItem[] = priceTypeList;
  qtyLabel: string = '張數';
  get period(): string {
    return this.stktsSrv.period;
  }
  set period(value: string) {
    this.stktsSrv.period = value;
    this.qtyLabel = jkLib.iif(this.isOdd(), '股數', '張數');
  }
  _priceType: string = '0';
  get priceType(): string {
    return this._priceType;
  }
  set priceType(value: string) {
    this._priceType = value;
    // 委託價格 0:限價 「M」表示參考價（昨收價）、「H」表示漲停價、「L」表示跌停價
    if (this._priceType === '0') {
      this.stktsSrv.newItem.TS009 = jkLib.fixString(this.stklg.LG010);
      this.stktsSrv.tradeType = '0'; //0:ROD
    } else if (this._priceType === 'M') {
      this.stktsSrv.newItem.TS009 = 'M'; // 昨收價
      //this.stktsSrv.tradeType = '1'; // IOC
    } else if (this._priceType === 'H') {
      this.stktsSrv.newItem.TS009 = 'H'; // 漲停價
      //this.stktsSrv.tradeType = '1'; // IOC
    } else if (this._priceType === 'L') {
      this.stktsSrv.newItem.TS009 = 'L'; // 跌停價
      //this.stktsSrv.tradeType = '1'; // IOC
    }
  }
  get account(): string {
    return this.stktsSrv.newItem.TS002;
  }
  set account(value: string) {
    this.stktsSrv.newItem.TS002 = value;
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.stkmaSrv.stockListReady.subscribe(() => {
      this.cdr.markForCheck();
    });
  }
  override ngAfterViewInit() {
    super.ngAfterViewInit();
    setTimeout(() => {
      if (this.stkmbSrv().accountList.length > 0)
        this.account = this.stkmbSrv().accountList[0].id;
      this.cdr.markForCheck();      // 手動觸發變更檢測以符合 zoneless 模式
    }, 1000);
  }
  afterGridReady($event: JkgridwinComponent) {
    this.stktsGrid = $event;
    //this.doQuery();
  }
  afterGridReadyBalance($event: JkgridwinComponent) {
    this.balanceGrid = $event;
    //this.doQuery();
  }
  doQuerybalanceGrid(type: number) {
    let where = ``;
    if (type === 1) {
      // 庫存報價明細查詢
      where += ` AND MT002='${this.account}' `;
      this.balanceGrid.doQuery2('STKMT', 'S01', 'S', where);
    } else if (type === 2) {
      //即時證券庫存
      //  MQ002=:MQ002 AND LG001='20241101'
      where += ` AND MQ002='${this.account}' AND LG001='${this.date}'`;
      this.balanceGrid.doQuery2('STKMQ', 'S03', 'S', where);
    } else if (type === 3) {
      //庫存彙總查詢
      where += ` AND MS002='${this.account}' AND LG001='${this.date}'`;
      this.balanceGrid.doQuery2('STKMS', 'S02', 'S', where);
    }
  }
  doQuery() {
    if (!this.account) return;
    let where = ` AND TS001='${this.date}' AND TS002='${this.account}'`;
    this.stktsGrid.doQuery2('STKTS', 'S01', 'S', where);
  }
  // 零股
  isOdd(): boolean {
    return (
      this.stktsSrv.newItem.TS006 === 2 ||
      this.stktsSrv.newItem.TS006 === 3 ||
      this.stktsSrv.newItem.TS006 === 4
    );
  }
  stklg: Stklg = new Stklg(); //
  stkmq: Stkmq = new Stkmq(); //
  get stockno(): string {
    return this.stktsSrv.newItem.TS005;
  }
  set stockno(value: string) {
    let r: any = this.stkmaSrv.idNameList.find((item) => item.id === value);
    if (r) {
      this.stktsSrv.newItem.TS005 = r.id;
      this.stktsSrv.newItem.TS004 = r.ps1; // 0:上市上櫃1:興櫃
      this.stktsSrv.newItem.TS029 = r.name;
      this.getStklg(value);
      this.getStkmq(value);
    } else {
      this.stktsSrv.newItem.TS029 = '';
      this.stktsSrv.newItem.TS005 = '';
    }
  }
  getStkmq(value: string) {
    let sql = `SELECT * FROM STKMQ WHERE MQ001='${value}'`;
    this.orm.simpleSql(this.serverUrl, sql).subscribe((value: any) => {
      if (value && value.length > 0) this.stkmq = value[0];
      else {
        this.stkmq = new Stkmq();
      }
    });
  }
  async doSend() {
    let bool = await this.stktsSrv.doBeforeSend(this.stkmbSrv().uId);
    if (bool) {
      this.doSaveRemember();
      let body = {
        prid: 'SendStockOrder',
        item: this.stktsSrv.newItem,
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        this.page.showToast('委託成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();
      } else {
        await this.page.showAlert('委託失敗:' + ret.getResultError());
      }
    }
  }

  getStklg(stockno: string) {
    this.stklgSrv.getDay(jkLib.nowDate(), stockno).subscribe((value: any) => {
      if (value && value.length > 0) this.stklg = value[0];
      this.stktsSrv.newItem.TS009 = jkLib.fixString(this.stklg.LG010);
    });
  }
  onDateValueChange($event: string) {
    this.doQuery();
    this.doQueryReply();
  }
  async doChangePrice() {
    let item: Stkts = this.stktsGrid.gridSrv.getFocusedRowData();
    if (item) {
      let newPrice = await this.page.showInput(
        '價格:',
        '請輸入新價格',
        item.TS009,
        'text'
      );
      if (!newPrice) return;
      // Long CorrectPriceBySeqNo([in] BSTR bstrLogInID, [in] VARIANT_BOOL bAsyncOrder, [in] BSTR bstrAccount,
      //[in] BSTR bstrSeqNo, [in] BSTR bstrPrice, [in] LONG nTradeType,[out] BSTR* bstrMessage);
      let body = {
        prid: 'CorrectPriceBySeqNo', //證期權改價
        table: 'STKTS',
        key1: item.TS001,
        key2: item.TS002,
        key3: item.TS003,
        price: newPrice,
        tradeType: item.TS011, // 證券0:ROD   期選0:ROD  1:IOC  2:FOK
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('改價成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();
      } else {
        await this.page.showAlert('改價失敗:' + ret.getResultError());
      }
    } else {
      await this.page.showAlert('請先選擇委託單');
    }
  }
  async doChangeQty() {
    let item: Stkts = this.stktsGrid.gridSrv.getFocusedRowData();
    if (item) {
      let decreaseQty = await this.page.showInput(
        this.qtyLabel,
        '請輸入取消' + this.qtyLabel,
        item.TS010.toString(),
        'text'
      );
      if (!decreaseQty) {
        return;
      }

      let body = {
        prid: 'DecreaseOrderBySeqNo', //
        key1: item.TS001,
        key2: item.TS002,
        key3: item.TS003,
        table: 'STKTS',
        decreaseQty: jkLib.fixNumber(decreaseQty),
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('修改數量成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();
      } else {
        await this.page.showAlert('修改數量失敗:' + ret.getResultError());
      }
    } else {
      await this.page.showAlert('請先選擇委託單');
    }
  }
  async doDelete() {
    let item = this.stktsGrid.gridSrv.getFocusedRowData();
    if (item) {
      let body = {
        prid: 'CancelOrderBySeqNo', //
        key1: item.TS001,
        key2: item.TS002,
        key3: item.TS003,
        table: 'STKTS',
      };
      let ret: jkRestReturn = await this.stockSrv.kmSaiPost(body);
      if (ret.result) {
        await this.page.showToast('刪單成功');
        this.masterTabGroupIndex = 1;
        this.doQuery();
      } else {
        await this.page.showAlert('刪單失敗:' + ret.getResultError());
      }
    } else {
      await this.page.showAlert('請先選擇委託單');
    }
  }
  doLoadRemember() {
    jkLib.loadLocalStorageItem('stkts', this.stktsSrv.newItem);
  }
  doSaveRemember() {
    jkLib.saveLocalStorageItem('stkts', this.stktsSrv.newItem);
  }
  afterGridReadyReply($event: JkgridwinComponent) {
    this.replyGrid = $event;
  }
  doQueryReply() {
    if (!this.account) return;
    let where = ` AND Broker+CustNo='${this.account}' AND Date1='${this.date}'`;
    this.replyGrid.doQuery2('STKLM', 'S01', 'S', where);
  }
  doQueryBalance() {
    if (!this.account) return;
    let where = ` AND Broker+CustNo='${this.account}' AND Date1='${this.date}'`;
    this.replyGrid.doQuery2('STKLM', 'S01', 'S', where);
  }
  async doComfirm() {
    // 回報過帳
    let item: any = this.replyGrid.itemFocused;
    if (!item) return;
    let ret = await this.stklmSrv.confirm(item, this.serverUrl);
    if (ret.result) {
      await this.page.showToast('回報成功');
    } else {
      await this.page.showAlert('回報失敗');
    }
  }
  doOpenwinStock($event: MouseEvent) {
    let param: JkOpenwinParams = {
      isModal: true,
      maintable: 'STKMQ',
      item: 'W01',
      params: [this.account],
      isMultiSelect: true,
      filterVisible: true,
      valueExpr: 'MQ001',
      displayExpr: 'MA002',
      returnData: [],
    };
    /*
    this.page.doOpenWinClick(param, (values: any) => {
      if (values) {
        this.stockno = values[0].id;
      }
    });
    */
  }
  checkLittleQty(qty: number) {
    let littleQty = qty % 1000;
    let bigQty = (qty - littleQty) / 1000;
    if (littleQty === 0) {
      this.period = '0';// { id:"0" , name:"盤中" },{ id:"1" , name:"盤後" },{ id:"2" , name:"盤後零股" },{ id:"4" , name:"盤中零股" } ] ; // 分類
      this.stktsSrv.qty = bigQty;
    } else {
      this.period = '4';
      this.stktsSrv.qty = littleQty;
    };
    if (this.stktsSrv.qty > 0) {
      this.stktsSrv.buysale = '1';// 0:買進 1:賣出
    } else {
      this.stktsSrv.buysale = '0';
    }
  }
  balanceGridDoubleClick($event: RowDoubleClickedEvent<any, any>) {
    // TODO:未測完
    let selectedItem = $event.data;
    if (selectedItem) {
      if (this.balanceGrid.maintable === 'STKMT') {
        this.stockno = selectedItem.MT001;
        this.checkLittleQty(selectedItem.MT005);
      } else if (this.balanceGrid.maintable === 'STKMQ') {
        this.stockno = selectedItem.MQ001;
        this.checkLittleQty(selectedItem.MQ018);
        /*this.stktsSrv.qty = selectedItem.MQ018;
        // stkts006List =  [ { id:"0" , name:"盤中" },{ id:"1" , name:"盤後" },{ id:"2" , name:"盤後零股" },{ id:"4" , name:"盤中零股" } ] ; // 分類
        let littleQty = selectedItem.MQ018 % 1000;
        if(littleQty === 0){
          this.period = '0';
        }else // 零股
          this.period = '4';*/
      } else if (this.balanceGrid.maintable === 'STKMS') {
        this.stockno = selectedItem.MS001;
        //this.stktsSrv.qty = selectedItem.MS007;
        this.checkLittleQty(selectedItem.MS007);
      }
      this.masterTabGroupIndex = 0;
    }
  }
  doBalanceGrid2Order() {
    let selectedItem = this.balanceGrid.selectedItem;
    let e = { data: selectedItem }; // : RowDoubleClickedEvent
    this.balanceGridDoubleClick(e as RowDoubleClickedEvent);
  }
}
